import React from 'react';
import './Chapters.scss';
function Chapter7() {
  return (
    <section className="chapter" style={{ marginBottom: '4rem' }}>
      <h3 className="chapter__title">Connecting Globally</h3>
      <p className="chapter__paragraph">
        With cloud technology, AWS and organizations like RONIN are helping researchers solve
        complex challenges in genomics, biochemistry, and more by accelerating data analysis with
        virtually unlimited compute. As a result, Dr. Hogg’s cloud-enabled library empowers other
        institutions’ researchers to share data and build a global resource.
      </p>
      <p className="chapter__paragraph">
        And with the planet’s biodiversity dependent on far more than any one region or country,
        global collaboration is critical.
      </p>
      <p className="chapter__paragraph">
        “Solutions are not going to come from one scientist or one industry,” Dr. Hogg says. “It
        really is [about] how you partner [with] everybody who’s got a variety of different
        expertise to make sure that we can really move ourselves forward and build a better planet.”
      </p>
    </section>
  );
}

export default Chapter7;
